import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import FormacionLayout from './FormacionLayout';
import LaeCategorias from './pages/LaeCategorias';
import LaeCursos from './pages/LaeCursos';
import LaeCursoForm from './pages/LaeCursoForm';
import Proveedores from './pages/Proveedores';
import { FormGuard } from './FormacionAccess';
// Cursos SEPE
import SepeAreas from '../sepeformacion/pages/SepeAreas';
import SepeConvocatorias from '../sepeformacion/pages/SepeConvocatorias';
import SepeCursos from '../sepeformacion/pages/SepeCursos';
import SepeCursoForm from '../sepeformacion/pages/SepeCursoForm';
import SepeAlumnosPotenciales from '../sepeformacion/pages/SepeAlumnosPotenciales';

export const formacionRoutes = (
  <Route path="/formacion" element={<FormacionLayout />}>
    <Route index element={<Navigate to="lae/cursos" replace />} />

    {/* — LAE Formación — */}
    <Route path="lae/cursos"        element={<FormGuard anyOf={['formacion.lae.cursos.view']}><LaeCursos /></FormGuard>} />
    <Route path="lae/cursos/nuevo"  element={<FormGuard anyOf={['formacion.lae.cursos.manage']}><LaeCursoForm /></FormGuard>} />
    <Route path="lae/cursos/:id"    element={<FormGuard anyOf={['formacion.lae.cursos.view']}><LaeCursoForm /></FormGuard>} />
    <Route path="lae/categorias"    element={<FormGuard anyOf={['formacion.lae.categorias.view']}><LaeCategorias /></FormGuard>} />

    {/* — Común — */}
    <Route path="proveedores"       element={<FormGuard anyOf={['formacion.proveedores.view']}><Proveedores /></FormGuard>} />

    {/* — Cursos SEPE — */}
    <Route path="sepe/cursos"         element={<FormGuard anyOf={['formacion.sepe.cursos.view']}><SepeCursos /></FormGuard>} />
    <Route path="sepe/cursos/nuevo"   element={<FormGuard anyOf={['formacion.sepe.cursos.manage']}><SepeCursoForm /></FormGuard>} />
    <Route path="sepe/cursos/:id"     element={<FormGuard anyOf={['formacion.sepe.cursos.view']}><SepeCursoForm /></FormGuard>} />
    <Route path="sepe/areas"          element={<FormGuard anyOf={['formacion.sepe.areas.view']}><SepeAreas /></FormGuard>} />
    <Route path="sepe/convocatorias"  element={<FormGuard anyOf={['formacion.sepe.convocatorias.view']}><SepeConvocatorias /></FormGuard>} />
    <Route path="sepe/alumnos-potenciales" element={<FormGuard anyOf={['formacion.sepe.alumnos.view']}><SepeAlumnosPotenciales /></FormGuard>} />
  </Route>
);

export default formacionRoutes;
